import { Checkbox, CheckboxProps } from "@chakra-ui/react";
import { useState } from "react";

interface StrongCheckBoxProps extends CheckboxProps {
    isChecked: boolean;
    onCheckChange?: (checked: boolean) => void;
}

const StrongCheckBox: React.FC<StrongCheckBoxProps> = ({ isChecked, onCheckChange, ...props }) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        if (onCheckChange) {
          onCheckChange(checked); // Return true or false
        }
    };
    
    return <Checkbox isChecked={isChecked} onChange={handleChange} {...props} />;
};

export default StrongCheckBox;